import styled from '@emotion/styled'
import { PharmacAccordion, PharmacAccordionContent, PharmacAccordionHandle } from '@pharmac/ui'
import React, { PropsWithChildren } from 'react'
import { ExtranetContainer } from '..'

export type DraggableAttributes = {
  role: string
  tabIndex: number
  'aria-disabled': boolean
  'aria-pressed': boolean | undefined
  'aria-roledescription': string
  'aria-describedby': string
}

export type SyntheticListenerMap = Record<string, Function>

type FaqCategoryAccordionProps = PropsWithChildren & {
  contents?: React.ReactNode | React.ReactNode[]
  dndRef?: (node: HTMLElement | null) => void
  dndStyle?: {
    transform?: string
    transition?: string
  }
  attributes?: DraggableAttributes
  listeners?: SyntheticListenerMap
}

const AccordionContainer = styled.div`
  width: 100%;
  margin-bottom: 0.1rem;
  touch-action: manipulation;
`

export const FaqCategoryAccordion = ({
  children,
  contents,
  dndRef,
  dndStyle,
  attributes,
  listeners,
}: FaqCategoryAccordionProps) => {
  return (
    <AccordionContainer
      ref={dndRef}
      style={dndStyle}
      {...attributes}
      {...listeners}
    >
      <PharmacAccordion
        handle={({ isOpen }: any) => (
          <PharmacAccordionHandle
            color="secondary"
            isOpen={isOpen}
          >
            <ExtranetContainer
              style={{ width: '97%' }}
              spaceBetween
              alignCenter
            >
              {children}
            </ExtranetContainer>
          </PharmacAccordionHandle>
        )}
      >
        <PharmacAccordionContent color="secondary">{contents}</PharmacAccordionContent>
      </PharmacAccordion>
    </AccordionContainer>
  )
}
